module.exports = __webpack_public_path__ + "static/media/supply_kit_2.836092ce.png";